import type { SongwriterSubmissionSuggestion } from '@Entities/rightsholder/songwriter-submission-suggestion'
import type { WorkModel } from '@Entities/work/work'
import { TableRowData } from '@Components/ViewWork/Table/index'
import React from 'react'
import { tableCellSanitizer } from '@App/helpers/table-cell-sanitizer'
import Navigation from '@App/navigation/index'
import type { NavigateFunction } from 'react-router'
import StatusPill from '@Components/StatusPills/StatusPill/index'
import formatRequestDate from '@Scenes/RightsholderScene/ChangeRequests/format-request-date'

export interface EnrichedSuggestion extends SongwriterSubmissionSuggestion {
    work?: WorkModel
}

export const buildTableRows = (
    changeRequests: EnrichedSuggestion[],
    rightsholderIpId: number,
    navigate: NavigateFunction,
    onDismiss?: (suggestionId: number) => void
): TableRowData[] =>
    changeRequests.map((changeRequest) => {
        const cells: React.ReactNode[] = [
            <div key="request-for">
                <div>Request For:</div>
                <strong>Update Shares</strong>
            </div>,
            <div key="request-date">
                <div>Request Date</div>
                <strong>{formatRequestDate(changeRequest.createdAt)}</strong>
            </div>,
            <div key="work-title">
                <div>Work</div>
                <strong>{tableCellSanitizer(changeRequest.work?.title)}</strong>
            </div>,
            <div key="song-code">
                <div>MLC Song Code</div>
                <strong>{tableCellSanitizer(changeRequest.work?.songCode)}</strong>
            </div>,
            <div key="requested-by">
                <div>Requested By</div>
                <strong>{tableCellSanitizer(changeRequest.songwriterName)}</strong>
            </div>,
        ]

        if (changeRequest.status === 'SUBMITTED') {
            cells.push(
                <div key="actions" className="actions">
                    <button
                        className="review-btn"
                        onClick={() =>
                            navigate(
                                Navigation.rightholder.catalog.changeRequests.view(rightsholderIpId, changeRequest.id),
                                {
                                    state: { suggestion: changeRequest },
                                }
                            )
                        }
                    >
                        Review
                    </button>
                    {onDismiss && (
                        <button className="dismiss-btn" onClick={() => onDismiss(changeRequest.id)}>
                            Dismiss
                        </button>
                    )}
                </div>
            )
        } else {
            cells.push(
                <div key={`status-${changeRequest.id}`}>
                    <StatusPill text={changeRequest.status === 'APPROVED' ? 'Approved' : 'Dismissed'} color="gray" />
                </div>
            )
        }

        return { cells, removable: false }
    })
